import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.path ? (
            <Link
              to={item.path}
              className="text-foreground-600 transition-colors hover:text-primary-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-base text-foreground-400" />
          )}
        </span>
      ))}
    </nav>
  );
}